"use strict";
/**
 * Created by rouven on 13.06.17.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.stepForwardPreservingErrors = exports.setError = exports.stepBack = exports.stepForward = exports.destroyWizard = exports.initializeWizard = void 0;
var types = __importStar(require("./actionTypes"));
var initializeWizard = function (name) { return ({
    type: types.INITIALIZE,
    name: name
}); };
exports.initializeWizard = initializeWizard;
var destroyWizard = function (name) { return ({
    type: types.DESTROY,
    name: name
}); };
exports.destroyWizard = destroyWizard;
var stepForward = function (name) { return ({
    type: types.STEP_FORWARD,
    name: name
}); };
exports.stepForward = stepForward;
var stepBack = function (name) { return ({
    type: types.STEP_BACK,
    name: name
}); };
exports.stepBack = stepBack;
var setError = function (name, error) { return ({
    type: types.SET_ERROR,
    name: name,
    error: error
}); };
exports.setError = setError;
var stepForwardPreservingErrors = function (name) { return ({
    type: types.STEP_FORWARD_PRESERVING_ERRORS,
    name: name
}); };
exports.stepForwardPreservingErrors = stepForwardPreservingErrors;
